/*
 * The quantity +/- controls in the cart drawer/page are plain `<a href="/cart/change?...">`
 * links, meant to be intercepted by the theme's own JS to do the quantity update over AJAX. If
 * that JS hasn't attached yet — reproduced by opening the cart drawer and tapping +/- again
 * within roughly a second — the click falls through to a real navigation: the browser loads
 * /cart/change, Shopify processes it and redirects back, and from the user's side the cart drawer
 * just closes and the page reloads.
 *
 * This permanently blocks that fallback: any click on a `/cart/change` link has its default
 * browser action (navigating) cancelled unconditionally, in the capture phase, before the click
 * even reaches the link. Calling preventDefault() here does not stop the event from continuing on
 * to the theme's own listener — that only cancels the browser's built-in "follow this link"
 * behavior, not other JS reacting to the same click — so the theme's real AJAX quantity update
 * still runs normally whenever its handler is attached, whether that's before, during, or shortly
 * after this one. Worst case, if the theme's handler genuinely isn't ready yet, the click is a
 * harmless no-op instead of a jarring full-page refresh.
 */
document.addEventListener(
  'click',
  function (event) {
    var link = event.target && event.target.closest ? event.target.closest('a[href*="/cart/change"]') : null;

    if (link) {
      event.preventDefault();
    }
  },
  true
);
